import { useTranslation } from 'react-i18next'

import { Divider, Text } from '@reveni-io/reveni-ui'

import DeliveryMethods from './DeliveryMethods/DeliveryMethods'

const AvailabilityCriterionUsedIn = ({ criterionId, deliveryMethods, regions, loading }) => {
  const { t } = useTranslation()

  if (criterionId === 'new' || criterionId?.startsWith('duplicate-')) return null

  return (
    <>
      <Divider />
      <Text type="titleM">{t('Criterios usados en')}:</Text>
      <DeliveryMethods deliveryMethods={deliveryMethods} regions={regions} loading={loading} />
    </>
  )
}

export default AvailabilityCriterionUsedIn
